import OldUserManage from '@/pages/oldPlatform/oldUserManage'

export default [
  {
    path: '/oldUserManage',
    name: 'OldUserManage',
    component: OldUserManage,
    meta: { name: '用户管理', keepAlive: true }
  }
]



// WEBPACK FOOTER //
// ./src/router/oldPlatform/oldUserManage.js